import styled from "styled-components"

// Component
import UnauthorizedPage from "./UnauthorizedPage"

export default styled(UnauthorizedPage)`
  height: 100%;
`
